import React, { useState } from "react";
import './Home.css';
import Navbar from "../component/navbar/nav";
import Footer from "../component/navbar/footer";
import Vehicle360Card from "./react-three-fiber";

// Import images
import topImage from '../assets/img/64119caec8c47e3fdbe2624f_low-deck-vs-hight-deck_1920X1080.jpg';
import img1 from '../assets/img/maintenance.webp';
import img2 from '../assets/img/card_2.webp';
import img3 from '../assets/img/card_3.webp';
import img4 from '../assets/img/red/00.png';
import img5 from '../assets/img/yellow/00.png';
import img6 from '../assets/img/blue/00.png';
import img7 from '../assets/img/green/00.webp';
import img8 from '../assets/img/comfort.webp';
import img9 from '../assets/img/product_reliability_icon_1_.webp';
import img10 from '../assets/img/maxima_c_featureimage.webp';
import EmiCalculator from "./EmiCalculator";
// Featured products data
const featuredProducts = [
  { id: 1, image: img4, name: 'Product 1' },
  { id: 2, image: img5, name: 'Product 2' },
  { id: 3, image: img6, name: 'Product 3' },
  { id: 4, image: img7, name: 'Product 4' }
];



// Featured Products Component
const FeaturedProductsSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % featuredProducts.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + featuredProducts.length) % featuredProducts.length);
  };

  return (
    <div className="featured-products">
      <h2>Featured Products</h2>
      <div className="product-slider">
        {/* <button className="nav-arrow left-arrow" onClick={prevSlide}>
          &lt;
        </button> */}

        <div className="product-carousel">
          {featuredProducts.map((product, index) => (
            <div
              key={product.id}
              className={`product-card ${index === currentIndex ? 'active' : ''}`}
              style={{
                opacity: index === currentIndex ? 1 : 0.6,
                transform: `scale(${index === currentIndex ? 1 : 0.9})`,
                transition: 'all 0.3s ease'
              }}
            >
              <img src={product.image} alt={product.name} />
              <h3>{product.name}</h3>
            </div>
          ))}
        </div>

        {/* <button className="nav-arrow right-arrow" onClick={nextSlide}>
          &gt;
        </button> */}
      </div>
    </div>
  );
};

const Home = () => {
  const [loanAmount, setLoanAmount] = useState("");
  const [tenure, setTenure] = useState("");
  const [interestRate, setInterestRate] = useState(12);
  const [emi, setEmi] = useState(0);

  const [value,setValue]=useState(50);
  const [kmPerDay, setKmPerDay] = useState(100);
  const [dieselPrice, setDieselPrice] = useState(90);
  const [cngPrice, setCngPrice] = useState(80);

  const annualSavings = ((dieselPrice - cngPrice) * kmPerDay * 365) / 20; // simplistic formula

  return (
    <div className="home-container">
      <Navbar />

      {/* Hero Section */}
      <section className="top-container">
        <img src={topImage} alt="Vehicle showcase" className="top-image" />
      </section>

      {/* 360 Viewer Section */}
      <div className="vehicle-360-card">
        <Vehicle360Card />
      </div>

      {/* 360 Viewer Section */}
      <div className="Benefits-for-you">
        <h3>Benefits for you</h3>
        <div className="Benefits-card-section">
        <div className="Benefits-cards">
          <img src={img1} alt="" />
          <h5>Maintenance</h5><br></br>
          <p>BS6 engine and durable chassis for low maintenance.</p>
          </div>
        <div className="Benefits-cards">
          <img src={img8}  alt="" />
          <h5>Comfort</h5><br></br>
          <p>CV shaft with dual front shock absorber for comfortable noiseless rides on any road.</p></div>
        <div className="Benefits-cards">
          <img src={img9}  alt="" />
          <h5>Product Reliability</h5><br></br>
          <p>100,000 kms or 3 years (Diesel) | 40,000 kms or 12 months (CNG, Petrol and LPG). </p></div>
        <div className="Benefits-cards">
          <img src={img10}  alt="" />
          <h5>Multi-load Application</h5><br></br>
          <p>Outstanding loading capacity. Carry heavy loads on difficult terrains with better torque.</p></div>
        <div className="Benefits-cards">
          <img src={img2}  alt="" />
          <h5>Performance</h5><br></br>
          <p>Superior 4-stroke engine for higher power and torque.</p></div>
      
        </div>
  
      
      </div>

      {/* Calcuattor Section*/}
      <div className="Calculate">
  <div className="Calculate-image">
    <img src={img6} alt="savings" />
  </div>
  
  <div className="Calculate-your-savings-area">
    <h3>Calculate your savings - Diesel to CNG</h3>
  <div  className="Emi-calculator-area">
<div className="Kms-tavel">
<p>Enter your vehicle usage and fuel cost in your city</p>
<p className="km-day">
  Km/Day
  </p>
  <p>
  {kmPerDay} Km
  </p>
<input
        type="range"
        min="0"
        max="250"
        value={kmPerDay}
        step="1"
        onChange={(e) => setKmPerDay(e.target.value)}
        style={{ width: '100%' }}
/>

</div>

<div className="fuel-price-section">
        <div className="fuel-card price-card">
          <span className="fuel-price-title">Diesel price</span>
          <span className="fuel-price-subtitle">Price/litre ₹</span>
          <input
            type="range"
            className="fuel-slider"
            min="80"
            max="120"
            value={dieselPrice}
            onChange={(e) => setDieselPrice(Number(e.target.value))}
          />
          <span className="fuel-slider-value">{dieselPrice}</span>
        </div>

        <div className="fuel-card price-card">
          <span className="fuel-price-title">CNG price</span>
          <span className="fuel-price-subtitle">Price/kg ₹</span>
          <input
            type="range"
            className="fuel-slider"
            min="30"
            max="100"
            value={cngPrice}
            onChange={(e) => setCngPrice(Number(e.target.value))}
          />
          <span className="fuel-slider-value">{cngPrice}</span>
        </div>
      </div>

      <div className="fuel-card result-card">
        <strong className="fuel-result-text">
          Annual savings up to: ₹ {annualSavings.toLocaleString("en-IN")}/-*
        </strong>
      </div>
  </div>
  </div>
</div>


      {/* Finance Banner */}
      <div className="Calculate">
  <div className="Calculate-image">
    <img src={img5} alt="savings" />
  </div>
  <EmiCalculator/>
  </div>

      {/* Featured Products */}
      <FeaturedProductsSlider />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;
